import $ from 'jquery';
import '../scss/index.scss';
import configureSearch from './frontend/search';

document.addEventListener('DOMContentLoaded', () => {
  // Set up the search
  configureSearch();

  // Breadcrumb modifications
  const $breadcrumbLinks = $('.breadcrumbs a');
  $breadcrumbLinks.last().removeAttr('href').css('text-decoration', 'none');
  $breadcrumbLinks.first().html('<i class="fas fa-home"></i>');
}, false);
